import firebase from "firebase/compat/app";
import 'firebase/compat/firestore'
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBE9t_1KtFJXHk2f8z4Ja62pch-WeC9ra8",
    authDomain: "horizon-2k22.firebaseapp.com",
    projectId: "horizon-2k22",
    storageBucket: "horizon-2k22.appspot.com",
    messagingSenderId: "54266665087",
    appId: "1:54266665087:web:a48da50c76a93e08fb474a",
    measurementId: "G-X6G8V6DNN4"
  });


  var db=firebaseApp.firestore();
  export {db}